/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */

h5 = h5 || {};
h5.codecapture = {
   angularModule: angular.module('com.vmware.vsphere.client.codecapture', [])
};